module.exports = __webpack_public_path__ + "img/CE.52467e1a.png";